// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"392":"1f9cc07a","453":"23312620"}[chunkId] + ".chunk.js";
};